/**
 * AppealUserReportSheet
 *
 * Helper to show the Appeal User Report sheet using SheetService.
 * Matches Flutter's UserReportAppealScreen navigation:
 * lib/presentation/screens/user/user_report_appeal_screen.dart
 */

import React from 'react';
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { AppealUserReportContent } from './components/AppealUserReportContent';

/**
 * Show the appeal user report sheet
 *
 * @param container - Optional container element or screen key string
 * @param screenKey - Optional screen key of the route opening this sheet
 * @param fixedHeight - Fixed height for the sheet, from responsive.appealUserReportSheet.fixedHeight
 */
const show = (
  container?: HTMLElement | string | null,
  screenKey?: string,
  fixedHeight?: string,
) => {
  const SheetContent: React.FC = () => {
    return (
      <AppealUserReportContent
        onFinish={() => SheetService.close()}
      />
    );
  };

  SheetService.show({
    content: <SheetContent />,
    container,
    screenKey,
    fixedHeight,
    dismissible: false,
    closeOnClickOutside: false,
    scrollable: false,
  });
};

export const AppealUserReportSheet = {
  show,
};
